import React from "react";
import TopMenu from "../../NineMenu/Screens/OrderPage/TopMenu";

const OrderLayout = ({ children }) => {
  return (
    <div>
      <TopMenu />
      <main>{children}</main>
    </div>
  );
};

export default OrderLayout;
